import Edit from './PurchaserPaymentMethodsEdit'
import Main from './PurchaserPaymentMethodsMain'

const PurchaserPaymentMethods = {
  Edit,
  Main,
}

export default PurchaserPaymentMethods
